import { gql } from '@apollo/client'

export const GET_DISPLAY_RESTOCK_HISTORY = gql`
  query GetDisplayRestockHistory($input: DisplayRestockHistoryDataInput!) {
    displayRestockHistory(input: $input) {
      hasMore
      count
      results {
        scans {
          pointClouds {
            bucketFileName
            pointCount
            centroids
            metadata
            predicted
            keyframes {
              url
            }
            merchandiserStep
            recommendation {
              productRecommendations {
                upc
                count
              }
            }
          }
          employee {
            email
          }
        }
        transactions {
          upc
          credit
          debit
          numFacings
          fieldVerified
          memo
          dateCompleted
        }
        inventoryBefore {
          upc
          quantity
        }
        inventoryAfter {
          upc
          quantity
        }
      }
    }
  }
`
